import { Controller } from "@hotwired/stimulus";

// Switches preview between phone mockup and browser mockup.
// Reloads visible iframe(s) when design changes are saved.
export default class extends Controller {
  static targets = [
    "phoneFrame",
    "browserFrame",
    "phoneBtn",
    "browserBtn",
    "iframe",
    "browserIframe",
  ];
  static values = { previewUrl: String };

  connect() {
    this.#boundReload = this.#onFormSubmit.bind(this);
    this.#boundSortReload = () => this.reload();
    document.addEventListener("turbo:submit-end", this.#boundReload);
    document.addEventListener("sortable-list:reorder", this.#boundSortReload);
  }

  disconnect() {
    document.removeEventListener("turbo:submit-end", this.#boundReload);
    document.removeEventListener(
      "sortable-list:reorder",
      this.#boundSortReload,
    );
    clearTimeout(this.#reloadTimer);
  }

  showPhone() {
    this.phoneFrameTarget.classList.remove("hidden");
    this.browserFrameTarget.classList.add("hidden");
    this.phoneBtnTarget.classList.add("btn-active");
    this.browserBtnTarget.classList.remove("btn-active");
  }

  showBrowser() {
    this.phoneFrameTarget.classList.add("hidden");
    this.browserFrameTarget.classList.remove("hidden");
    this.browserBtnTarget.classList.add("btn-active");
    this.phoneBtnTarget.classList.remove("btn-active");

    if (!this.browserIframeTarget.src) {
      this.browserIframeTarget.src = this.previewUrlValue;
    }
  }

  reload() {
    clearTimeout(this.#reloadTimer);
    this.#reloadTimer = setTimeout(() => this.#doReload(), 100);
  }

  // Private

  #boundReload;
  #boundSortReload;
  #reloadTimer;

  #doReload() {
    const base = this.previewUrlValue;
    const url = `${base}${base.includes("?") ? "&" : "?"}_t=${Date.now()}`;

    if (!this.phoneFrameTarget.classList.contains("hidden")) {
      this.iframeTarget.src = url;
    }
    if (
      !this.browserFrameTarget.classList.contains("hidden") &&
      this.browserIframeTarget.src
    ) {
      this.browserIframeTarget.src = url;
    }
  }

  #onFormSubmit(event) {
    if (event.detail?.success) {
      this.reload();
    }
  }
}
